var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.jwt)?_c('vue-jitsi-meet',{ref:"jitsiRef",attrs:{"domain":"8x8.vc","options":_vm.jitsiOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }